import { Turnover } from 'components/employee-analytics/analytic-item/Turnover'
import { useState, useEffect } from 'react'
import { API_EMPLOYEE_ANALYTICS } from 'services/apiEmployeeAnalytics'
import { useFetch } from 'services/useFetch'
import moment from 'moment'

const INITIAL_FILTER = {
    year: moment().get('year'),
    company_ids: [],
    department_ids: [],
}

const TurnoverContainer = () => {
    const { fetching: getTurnover, isLoading } = useFetch(API_EMPLOYEE_ANALYTICS.TURNOVER)
    const [turnoverData, setTurnoverData] = useState([])
    const [filter, setFilter] = useState(INITIAL_FILTER)

    useEffect(() => {
        ;(async () => {
            const turnover = await getTurnover(filter)
            const newData = turnover?.data?.map((item) => ({
                ...item,
                month: moment()
                    .month(item?.month - 1)
                    .format('MMMM'),
            }))

            setTurnoverData(newData)
        })()
    }, [filter])

    const onSubmitFilter = (newFilter) => {
        if (JSON.stringify(filter) !== JSON.stringify(newFilter)) {
            setFilter(newFilter)
        }
    }

    const props = {
        data: turnoverData,
        isLoading,
        filter,
        onSubmitFilter,
    }

    return <Turnover {...props} />
}

export default TurnoverContainer
